export default __webpack_public_path__ + "static/media/medium.8ae93ddd.png";